module.exports = __webpack_public_path__ + "img/cardframe.0a22451f.webp";